import { Button, Layout, TextField } from '@lessonnine/design-system.lib';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
// External Imports
import { connect } from 'react-redux';

import { options } from '../../../config/reactRedux.mjs';
// Internal Imports
import { createSelectTranslation } from '../../../selectors/createSelectTranslation.mjs';
import { I18n } from '../../I18n/I18n.jsx';

// Component Definition
class SearchFieldBase extends Component {
  constructor(props) {
    super(props);

    this.state = { searchParam: props.params.s };
  }

  onInputChange = (inputEvent) => {
    this.setState({ searchParam: inputEvent.target.value });
  };

  onSubmit = (formEvent) => {
    formEvent.preventDefault();

    // Auto-hide mobile, software keyboards
    const blurElement = formEvent.currentTarget[0];
    blurElement.focus();
    blurElement.blur();

    const { onSubmit, params } = this.props;
    const { searchParam } = this.state;
    if (searchParam.trim()) {
      onSubmit({ ...params, s: searchParam });
    }
  };

  render() {
    const { getTranslation } = this.props;
    const { searchParam } = this.state;

    return (
      <Layout
        action="/"
        alignItems={{ xxsmall: 'center', xxxsmall: 'start' }}
        as="form"
        direction={{ xxsmall: 'inline', xxxsmall: 'stack' }}
        gap={8}
        onSubmit={this.onSubmit}
        role="search"
      >
        <TextField
          appearance="outlined"
          fullWidth
          name="search"
          onChange={this.onInputChange}
          placeholder={getTranslation('search', 'Search')}
          type="search"
          value={searchParam}
        />
        <Button type="submit">
          <I18n defaultText="Search" field="search" />
        </Button>
      </Layout>
    );
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { params } = this.props;
    if (!isEqual(params, newProps.params)) {
      this.setState({ searchParam: newProps.params.s });
    }
  }
}

SearchFieldBase.propTypes = {
  getTranslation: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  params: PropTypes.shape({
    s: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  getTranslation: createSelectTranslation(state),
});

const withRedux = connect(mapStateToProps, undefined, undefined, options);
const SearchField = withRedux(SearchFieldBase);

// Module Exports
export { SearchField };
